import React from 'react';

export default () => (
  <div class="nc-notFound-container">
    <h2>Not Found</h2>
  </div>
);



// WEBPACK FOOTER //
// ./components/App/NotFoundPage.js